import keys from 'lodash/keys';
import keyBy from 'lodash/keyBy';

export const getItemsAllergens = (items) => {
	return keys(items.reduce((acc, item) => {
		if (item.nutritionalInfo) {
			item.customizations.forEach(customization => {
				const variation = customization.variations.find(v => v.step === customization.current);
				if (variation?.nutritionalInfo?.allergies) {
					Object.assign(acc, keyBy(variation?.nutritionalInfo?.allergies));
				}
			});
		}
		return Object.assign(acc, keyBy(item.allergens));
	}, {}));
}